import React, { useEffect } from 'react';
import FadeIn from '../components/FadeIn';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft, FiMail, FiClock } from 'react-icons/fi';

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-[80vh] bg-white py-16 px-4 sm:px-6 lg:px-8 flex flex-col justify-center">
      <div className="max-w-2xl mx-auto w-full">
        <FadeIn>
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium mb-12 transition-colors group"
          >
            <SafeIcon icon={FiArrowLeft} className="mr-2 group-hover:-translate-x-1 transition-transform" /> 
            Back to Home
          </Link>

          <h1 className="text-4xl font-bold text-slate-900 mb-6">Contact Us</h1>
          
          <div className="prose prose-slate max-w-none text-slate-600 space-y-8 leading-relaxed">
            <p className="text-lg">
              Have questions about your purchase or need help accessing the <strong>7-Day Bill Panic Reset</strong> course? We're here to help you find your footing.
            </p>

            <div className="grid gap-6 mt-12">
              <div className="flex items-start p-6 rounded-2xl bg-slate-50 border border-slate-100">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4 shrink-0">
                  <SafeIcon icon={FiMail} className="text-blue-600 text-xl" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Email Support</h3>
                  <a 
                    href="mailto:websitebis@gmail.com" 
                    className="text-blue-600 hover:underline text-lg font-medium"
                  >
                    websitebis@gmail.com
                  </a>
                  <p className="text-sm text-slate-500 mt-2">
                    For all support and access inquiries.
                  </p>
                </div>
              </div>

              <div className="flex items-start p-6 rounded-2xl bg-emerald-50 border border-emerald-100">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mr-4 shrink-0">
                  <SafeIcon icon={FiClock} className="text-emerald-600 text-xl" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Response Time</h3>
                  <p className="text-slate-700">
                    We typically respond to all inquiries within <strong>24–48 business hours</strong>.
                  </p>
                </div>
              </div>
            </div>

            <p className="text-sm text-slate-500 pt-8 border-t border-slate-100 italic">
              Please include the email address used during purchase to help us assist you faster.
            </p>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}